import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { COLORS } from '../theme';

/**
 * Captura erros de render/lifecycle e mostra um fallback em vez de tela branca.
 * Não captura erros em event handlers (use try/catch nesses casos).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Mantém o console para Sentry/devtools; em produção pode ser trocado por
    // um reporter (ex.: Sentry.captureException(error)).
    console.error('[ErrorBoundary]', error, info?.componentStack);
    if (typeof this.props.onError === 'function') {
      this.props.onError(error, info);
    }
  }

  handleReload = () => {
    if (typeof window !== 'undefined') window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
          bgcolor: COLORS.offWhite,
        }}
      >
        <Stack spacing={2.5} alignItems="center" textAlign="center" maxWidth={480}>
          <ReportProblemOutlinedIcon sx={{ fontSize: 56, color: COLORS.orange }} />
          <Typography variant="h5" sx={{ fontWeight: 700, color: COLORS.textDark }}>
            Algo deu errado
          </Typography>
          <Typography variant="body2" sx={{ color: COLORS.gray900 }}>
            Encontramos um erro inesperado ao carregar esta tela. Recarregue a página para
            continuar. Se o problema persistir, avise o suporte.
          </Typography>
          <Button
            variant="contained"
            onClick={this.handleReload}
            sx={{
              bgcolor: COLORS.orange,
              color: COLORS.white,
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': { bgcolor: COLORS.orangeDeep },
            }}
          >
            Recarregar página
          </Button>
        </Stack>
      </Box>
    );
  }
}

export default ErrorBoundary;
